__turbopack_context__.v({
  "btn": "Pagination-module__QyWOzW__btn",
  "btnActive": "Pagination-module__QyWOzW__btnActive",
  "btnFlipped": "Pagination-module__QyWOzW__btnFlipped",
  "container": "Pagination-module__QyWOzW__container",
  "fadeInItems": "Pagination-module__QyWOzW__fadeInItems",
  "page": "Pagination-module__QyWOzW__page",
  "pageCurrent": "Pagination-module__QyWOzW__pageCurrent",
  "spacing--lg": "Pagination-module__QyWOzW__spacing--lg",
  "spacing--md": "Pagination-module__QyWOzW__spacing--md",
  "spacing--sm": "Pagination-module__QyWOzW__spacing--sm",
  "spacing--xl": "Pagination-module__QyWOzW__spacing--xl",
  "spacing--xs": "Pagination-module__QyWOzW__spacing--xs",
  "spacing--xxl": "Pagination-module__QyWOzW__spacing--xxl",
  "spacing--xxs": "Pagination-module__QyWOzW__spacing--xxs",
  "spacing--xxxl": "Pagination-module__QyWOzW__spacing--xxxl",
  "spacing--xxxs": "Pagination-module__QyWOzW__spacing--xxxs",
});
